import { formatAs, DateFnsFormats } from '../../../common-client2/src/services/ukgDateTime';
import { getLocations } from '../services/api-endpoints';

/**
 * @param {undefined|Date|string} effectiveDate 
 * @returns {ApiManager.GetLocationsResponse}
 */
export const getParsedLocations = async (effectiveDate = undefined) => {
    if (effectiveDate === undefined) {
        effectiveDate = formatAs(new Date(), DateFnsFormats.YMD);
    } else if (effectiveDate instanceof Date) {
        effectiveDate = formatAs(effectiveDate, DateFnsFormats.YMD);
    }
    //If string, the string passed as parameter is used
    const result = await getLocations(effectiveDate);
    return result.data;
}